/**
 * Created by Rodrigo Quesada on 12/05/17.
 */
import {Moment} from 'moment';
import moment = require('moment');

export class DateInfo {

    administeredDate?: Moment;
    expirationDate?: Moment;

    constructor(jsonData: any = {}) {
        if (jsonData.administeredDate) jsonData.administeredDate = moment(jsonData.administeredDate);
        if (jsonData.expirationDate) jsonData.expirationDate = moment(jsonData.expirationDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/liability/common/values/date-info.class.ts